import { IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from "@material-ui/core";
import React from "react";
import { InspectionRow } from "./InspectionRow";
import { Inspection } from "./Inspections";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
interface GridProps {
	Data: Array<Inspection>;
}

export function InspectionGrid(props: GridProps) {
	const [pageNumber, setPageNumber] = React.useState(1);

	const getRows = () => {
		const pn = pageNumber - 1;
		const startIdx = pn * 50;
		const endIdx = pageNumber * 50 - 1;

		return props.Data.slice(startIdx, endIdx);
	};

	return (
		<div style={{ overflowX: "auto", width: "100%" }}>
			<Table size="small" style={{ tableLayout: "fixed" }}>
				<TableHead>
					<TableRow>
						<TableCell style={{ width: "300px", whiteSpace: "nowrap" }}>Building</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Serial</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Mechanic</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Company</TableCell>
						<TableCell style={{ width: "100px", whiteSpace: "nowrap" }}>First Pass?</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>First Inspection</TableCell>
						<TableCell style={{ width: "100px", whiteSpace: "nowrap" }}>Second Pass?</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Second Inspection</TableCell>
						<TableCell style={{ width: "100px", whiteSpace: "nowrap" }}>Third Pass?</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Third Inspection</TableCell>
						<TableCell style={{ width: "200px", whiteSpace: "nowrap" }}>Expiration Date</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{getRows().map((x, idx) => (
						<InspectionRow key={x.ID} Data={x} />
					))}
				</TableBody>
				<TableFooter>
					<TableRow>
						<TableCell colSpan={9}></TableCell>
						<TableCell>
							<IconButton disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)}>
								<KeyboardArrowLeft></KeyboardArrowLeft>
							</IconButton>
							<Typography variant="body1" style={{ display: "inline" }}>
								{pageNumber}
							</Typography>
							<IconButton disabled={pageNumber === Math.ceil(props.Data.length / 50)} onClick={() => setPageNumber(pageNumber + 1)}>
								<KeyboardArrowRight></KeyboardArrowRight>
							</IconButton>
						</TableCell>
					</TableRow>
				</TableFooter>
			</Table>
		</div>
	);
}
